import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { MfaEmailWizard } from '../components/auth/MfaEmailWizard';

const schema = z.object({ session: z.string().min(1) });

export const Route = createFileRoute('/login/mfa-email-setup')({
    validateSearch: (s: Record<string, unknown>) => schema.parse(s),
    // AuthLayout lo provee el parent /login vía <Outlet />.
    component: MfaEmailWizard,
});
